import React, { useState } from 'react';
import { CheckCircle, CopyLink } from './Icons';

const CopyButton = ({ textToCopy }) => {
  const [copied, setCopied] = useState(false);

  const copyToClipboard = async () => {
    try {
      await navigator.clipboard.writeText(textToCopy);
      setCopied(true);
      setTimeout(() => setCopied(false), 1000);
    } catch (err) {
      console.error('Failed to copy!', err);
    }
  };

  return (
    <button className='ml-2' onClick={copyToClipboard}>
      {copied ? <CheckCircle /> : <CopyLink />}
    </button>
  );
};

export default CopyButton;
